import axios from 'axios';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess, loginFailure } from '../../authSlice';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import '../../styling/ClientPortal.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import BookingHeader from '../clientPortal/BookingHeader';
const ClientLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  // --- 1. Add error state ---
  const [error, setError] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const businessId = searchParams.get("businessId");

  const handleLogin = async () => {
    setError(null); // --- 2. Clear previous errors on new attempt ---
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/client-user/login`,
        { email: email.toLowerCase(), password }, // Also added .toLowerCase() for consistency
        { withCredentials: true }
      );
      
      const clientData = response.data.data;
      const clientWithRole = { ...clientData, role: 'Client' };

      // If there's a businessId, save it for App.js to use for the redirect
      if (businessId) {
        sessionStorage.setItem('loginBusinessId', businessId);
      }

      // Dispatch login success. This will cause App.js to redirect.
      dispatch(loginSuccess(clientWithRole));
      sessionStorage.setItem('userSession', JSON.stringify(clientWithRole));

    } catch (error) {
      console.error('Client login error:', error);
      // --- 3. Handle specific error statuses ---
      if (error.response && (error.response.status === 403 || error.response.status === 401)) {
        setError("Invalid Credentials. Please try again!");
      } else {
        setError(error.response?.data?.message || "An unexpected error occurred. Please try again.");
      }
      dispatch(loginFailure(error.message));
    }
  };   
  
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div>
      <BookingHeader />
      <div className="login-page-container">
        <div className="login-business">
          <div className="login-content">
          <div style={{ fontSize: '35px', color: '#1C1154', marginBottom: '20px' }}>
            Login
          </div>
          <div style={{fontSize: '15px', color: '#625C73', }}>
            {/* We emailed the detailed to boothcompany@email.com */}
          </div>
          
          <input
            type="email"
            name="email"
            placeholder="Email"
            className="login-input"
            value={email}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',    
                right: '0px',           
                top: '64%',              
                transform: 'translateY(-50%)', 
                cursor: 'pointer',       
                color: '#555'             
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {/* --- 4. Render the error message if it exists --- */}
          {error && <p style={{ color: "red", marginTop: "10px", marginBottom: "10px", textAlign: "center", fontSize: "14px" }}>{error}</p>}

          {/* Replace the old paddingLeft: '30%' with textAlign: 'center' */}
<div style={{ textAlign: 'center', color: '#545454', marginTop: error ? "0px" : "10px", width: "100%" }}>
  <Link to="/forgotClientPassword" style={{ textDecoration: "none" }}>
    <span style={{ textDecoration: "underline", color:"#4d4d4d", fontSize: '12px' }}>
      Forgot Password?
    </span>
  </Link>
</div>
          
          <button className="login-button" onClick={handleLogin}>
            Login
          </button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ClientLogin;